import axios from 'axios';
import { backendURL } from './consts';

export const getAttendence = async (token, params) => {
  const res = await axios.get(`${backendURL}/seminar/getAttendence`,
    {
      params,
      headers:{
        token:`bearer ${token}`
      }
    }
  );
  return res.data;
}